export default __webpack_public_path__ + "static/media/aakash-digital-logo.f1b191ac.png";